function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .action-opps-donors-choose_svg__action-opps-donors-choose_svg__st0{fill:#2F18BA}.action-opps-donors-choose_svg__action-opps-donors-choose_svg__st1{fill:#FFFFFF}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "action-opps-donors-choose_svg__action-opps-donors-choose_svg__st0",
  d: "M20,0.7C9.3,0.7,0.7,9.3,0.7,20c0,10.7,8.6,19.3,19.3,19.3c10.7,0,19.3-8.6,19.3-19.3 C39.3,9.3,30.7,0.7,20,0.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "action-opps-donors-choose_svg__action-opps-donors-choose_svg__st1",
  d: "M11.8,10.7H20c6.8,0,10.8,3.7,10.8,8.9c0,5.7-4.1,9.7-11.3,9.7h-7.7V10.7z M20.4,17.7h-1v4.4h1 c1.8,0,2.6-1,2.6-2.3C23,18.6,22.2,17.7,20.4,17.7"
}));

function SvgActionOppsDonorsChoose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgActionOppsDonorsChoose;